<template>
  <div class="demon-wrap">
    <!-- <div class="demon-table-btn">
      <a class="btn after-bdr" href="javascript:;"
        data-stat-id="cklyysb"
        @click="openTbHandler">查看利益演示表</a>
    </div> -->
    <sliding
      :show="show"
      :over-height="true"
      iconfont="icon-close_line"
      @close="handleClose"
    >
      <div class="navigation-wrap after-bd-b">
        <div class="navigation contrast-navigation after-bd-b">
          <nav class="nav">
            <a
              v-for="(pb, index) in pbList"
              :key="index"
              class="item"
              :class="{ cur: curPbIndex === index }"
              @click="handleChangePb(index)"
            >方案{{ (index + 1) | filterNumToChinese }}</a>
          </nav>
        </div>
      </div>

      <demon-table
        v-if="products.list.length && show"
        :contrast="true"
        :products="products"
        :profit="profit"
        :insured-age="insuredAge"
        :prop-start-year="startYear"
        :active-nav-left="activeNavLeft"
        @tb-product-change="handleChangePrd"
        @tb-rate-change="handleChangeRate"
        @tb-bonus-change="handleChangeBonus"
      />
      <template v-else>
        <bxs-default-page
          v-if="!loading"
          :large="!0"
          text="该方案暂无利益演示"
        />
      </template>
    </sliding>
  </div>
</template>

<script>
import qs from 'qs'
import DemonStrat from './src/demonstrat'
import DemonTable from './src/demontable'
import Sliding from 'base/sliding/sliding'
import { formatNumToChinese } from 'common/js/format'
import { initInterest, getInterest } from 'api/index'
import Vue from 'vue'
import { DefaultPage } from 'bxs-ui-vue'
Vue.use(DefaultPage)

const DEFAULT_INDEX = 0

export default {
  name: 'Dem',
  components: {
    DemonStrat,
    DemonTable,
    Sliding
  },
  filters: {
    filterNumToChinese(value) {
      return formatNumToChinese(value)
    }
  },
  props: {
    insuredAge: {
      type: Number,
      default: 0
    },
    pbList: Array,
    activeIndex: Number,
    visible: Boolean,
    result: Array
  },
  data() {
    return {
      uuid: null,
      loading: false,
      products: {
        list: [],
        value: '',
        type: 0,
        part: 0
      },
      activeNavLeft: 0,
      profit: [],
      show: false,
      curPbIndex: 0
    }
  },
  computed: {},
  watch: {
    activeIndex(value) {
      this.handleChangePb(value)
    },
    visible(value) {
      if (!value) return
      this.openProfitTable()
    }
  },
  created() {
    const { pbList } = this
    this.profitCache = {}
    this.uuid = pbList[0] && pbList[0].uuid
    this._fetchInit()
    appBridge.hideLoading()
  },
  mounted() {},
  methods: {
    _fetchInit(uuid = this.uuid) {
      this.loading = true
      uuid &&
        initInterest({
          uuid: uuid
        })
          .then(({ data: { data, success } } = { data: {} }) => {
            if (success) {
              data = this._filterProfit(data)
              if (data[DEFAULT_INDEX]) {
                let { products } = this
                let defaultPrd = data[DEFAULT_INDEX]

                this.startYear = products.startIndex = defaultPrd.startIndex
                products.startPolicyNo = defaultPrd.startPolicyNo
                if (defaultPrd.multiData.twoList) {
                  this.profit = defaultPrd.multiData.twoList
                } else {
                  this.profit = defaultPrd.multiData.oneList
                }
                this.products.value = defaultPrd.productId
                let uuidIndex = 0
                this.pbList.forEach((pb, index) => {
                  if (pb.uuid == uuid) {
                    uuidIndex = index
                  }
                })
                data.forEach(item => {
                  // 未配置取产品名
                  if (!item.productName) {
                    item.productName = this.findProductName(
                      this.result[uuidIndex].resultData.productGroupList[0]
                        .prodOrderList,
                      item.productId
                    )
                  }
                })
                this.products.list = data
                this.addAndTake = defaultPrd.addAndTakeData
                // 缓存初始化数据
                data.forEach(item => {
                  this._storageProfit(item)
                })
              }
            }
            this.loading = false
          })
          .catch(err => {
            console.log('err', err)
            this.loading = false
          })
    },
    // 获取
    _fetchProfit(product = {}) {
      const { productId, uuid, bonus, rate, extraTitle } = product
      const {
        profitCache,
        products: { type }
      } = this
      let parameter = {
        bonus: {},
        rate: {},
        uuid,
        productId
      }
      bonus && (parameter.bonus.value = bonus.value)
      rate && (parameter.rate.value = rate.value)
      extraTitle && extraTitle.length && (parameter.extraIndex = type)
      const profitKey = this._getProfitKey(bonus, rate, extraTitle)

      if (
        profitCache[uuid] &&
        profitCache[uuid][productId] &&
        profitCache[uuid][productId][profitKey]
      ) {
        this.profit = profitCache[uuid][productId][profitKey]
      } else {
        this.loading = true
        getInterest(
          qs.stringify({
            jd: JSON.stringify(parameter)
          })
        )
          .then(({ data, info, success } = {}) => {
            if (success) {
              this.profit = data
              // 获取利益演示（旧）
              // 拿到的是最终数据
              parameter.multiData = {
                oneList: data
              }
              this._storageProfit({
                extraTitle,
                ...parameter
              })
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    // 过滤
    _filterProfit(data) {
      let result = []

      // 过滤无数据
      if (Array.isArray(data)) {
        result = data.filter(item => {
          return (
            item.data.length ||
            (item.multiData &&
              ((item.multiData.twoList && item.multiData.twoList.length) ||
                (item.multiData.oneList && item.multiData.oneList.length)))
          )
        })
      }
      // 过滤自定义利率分红
      result.forEach(pd => {
        if (
          pd.bonus &&
          Array.isArray(pd.bonus.opts) &&
          pd.bonus.opts.length > 1
        ) {
          let tempMap = {}
          pd.bonus.opts = pd.bonus.opts.filter(option => {
            if (tempMap[option.value]) {
              return false
            } else {
              tempMap[option.value] = true
              return true
            }
          })
        }

        if (pd.rate && Array.isArray(pd.rate.opts) && pd.rate.opts.length > 1) {
          let tempMap = {}
          pd.rate.opts = pd.rate.opts.filter(option => {
            if (tempMap[option.value]) {
              return false
            } else {
              tempMap[option.value] = true
              return true
            }
          })
        }
      })

      return result
    },
    // 缓存
    _storageProfit({
      uuid,
      productId,
      multiData,
      bonus,
      rate,
      extraTitle
    } = {}) {
      const data = multiData.twoList || multiData.oneList
      const profitKey = this._getProfitKey(bonus, rate, extraTitle)
      if (!this.profitCache[uuid]) {
        this.profitCache[uuid] = {
          [productId]: {}
        }
      }
      if (this.profitCache[uuid][productId]) {
        this.profitCache[uuid][productId][profitKey] = data
      } else {
        this.profitCache[uuid][productId] = {
          [profitKey]: data
        }
      }
    },
    // 缓存's key
    _getProfitKey(bonus, rate, extraTitle) {
      let profitKey
      let tempBonusKey
      let tempRateKey
      const {
        products: { type }
      } = this

      if (bonus) {
        if (bonus.value || bonus.value === 0) {
          tempBonusKey = `bonus_${bonus.value}`
        } else {
          console.warn('bonus缺少默认值')
        }
      }
      if (rate) {
        if (rate.value || rate.value === 0) {
          tempRateKey = `rate_${rate.value}`
        } else {
          console.warn('rate缺少默认值')
        }
      }

      if (tempBonusKey && tempRateKey) {
        profitKey = `${tempBonusKey}-${tempRateKey}`
      } else {
        profitKey = tempBonusKey || tempRateKey || 'key'
      }
      if (extraTitle && extraTitle.length) {
        profitKey = `${type}-${profitKey}`
      }

      return profitKey
    },
    // 最长的数据
    _maxLen(profit) {
      let ary = profit.map(item => {
        return item.values.length
      })
      return Math.max(...ary)
    },
    // 打开表
    openProfitTable() {
      let dnavigation = document.querySelector(
        '.demonstration-container .navigation'
      )
      if (dnavigation) {
        this.activeNavLeft = dnavigation.scrollLeft
      }
      const { pbList, curPbIndex } = this
      this.uuid = pbList[curPbIndex] && pbList[curPbIndex].uuid
      this._fetchInit()
      this.show = true
    },
    updateLoading(state) {
      this.loading = state
    },
    findProductName(list, key) {
      const products = list.filter(item => {
        return item.key === key
      })
      return products[0] ? products[0].titleName : ''
    },
    handleClose() {
      this.show = false
      this.$emit('close')
    },
    // 切换方案
    handleChangePb(index) {
      const { pbList } = this
      this.curPbIndex = index
      this.uuid = pbList[index] && pbList[index].uuid
      this.products = {
        list: [],
        value: '',
        type: 0
      }
      this._fetchInit()
    },
    // 切换产品
    handleChangePrd(index) {
      const { list } = this.products
      const curProduct = list[index]
      this.products.value = curProduct.productId
      this.products.startIndex = curProduct.startIndex
      this._fetchProfit(curProduct)
    },
    // 切换类型
    changeTypeHandler(index) {
      const {
        products: { list, value }
      } = this
      const curProduct = list.find(item => {
        return item.productId === value
      })
      this.products.type = index
      this._fetchProfit(curProduct)
    },
    // 切换利率
    handleChangeRate(val, index) {
      const { list } = this.products
      const curProduct = list[index]
      if (curProduct && curProduct.rate) {
        this.products.list[index].rate.value = val
        this._fetchProfit(curProduct)
      }
    },
    // 切换分红
    handleChangeBonus(val, index) {
      let { list } = this.products
      let curProduct = list[index]
      if (curProduct && curProduct.bonus) {
        this.products.list[index].bonus.value = val
        this._fetchProfit(curProduct)
      }
    }
  }
}
</script>

<style lang="postcss">
@import 'variable';

.demon-table-btn {
  padding-bottom: 20px;
  font-size: 15px;
  text-align: center;
  .btn {
    display: inline-block;
    padding: 7px 21px;
    &:after {
      border-radius: 8px;
    }
    &:before {
      @apply --extend-click;
    }
  }
}

.navigation-wrap {
  width: 100%;
  padding-right: 45px;
  .contrast-navigation {
    margin-bottom: 0;
  }
}

.navigation {
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
  height: 45px;
  margin-bottom: -1px;
  background: var(--white-color);
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
    background-color: transparent;
  }
  .nav {
    /*overflow-y: hidden;*/
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 0;
    .item {
      position: relative;
      width: 33.3%;
      height: 100%;
      display: inline-block;
      font-size: 15px;
      background-color: var(--white-color);
      color: var(--nine-color);
      outline: none;
      vertical-align: middle;
      @apply --text-ellipsis;
      &:before {
        z-index: 2;
        content: '';
        position: absolute;
        bottom: 1px;
        opacity: 0;
        left: 41%;
        width: 18%;
        height: 4px;
        border-radius: 100px;
      }
    }
    .cur:before {
      opacity: 1;
    }
  }
}

.profit-condition {
  display: flex;
  margin: 0 auto 25px;
  padding: 0 14px;
  &.bonus-wrap {
    padding: 0 13px;
  }
  .profit-item {
    flex: 1;
    display: block;
    position: relative;
    margin-right: 3px;
    -webkit-tap-highlight-color: transparent;
    &:first-child {
      .profit-label:after {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
      input {
        &:checked + label {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
      }
    }
    &:last-child {
      margin-right: 0;
      .profit-label:after {
        width: 197%;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      input {
        &:checked + label {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
    .profit-label {
      display: block;
      padding: 6px;
      text-align: center;
      font-size: 12px;
      p {
        line-height: 13px;
        @apply --text-ellipsis;
      }
    }
    input[type='radio'] {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      appearance: none;
      vertical-align: middle;
      background: transparent;
      border: none;
    }
  }
}
.bonus-wrap {
  padding: 20px 14px;
  font-size: 15px;
  .select {
    display: inline-block;
    position: relative;
    -webkit-tap-highlight-color: transparent;
  }
  .bonus {
    padding: 0 30px 0 15px;
    font-size: 15px;
    line-height: 1;
    appearance: none;
    border: none;
    background-color: transparent;
    color: var(--diff-color);
  }

  .icon-arrow_down {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    line-height: 1;
    margin-top: -1px;
    color: var(--diff-color) !important;
  }
  .profit-item {
    .profit-label-in {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 26px;
      line-height: 13px;
    }
  }
}

.slide-pop {
  .close {
    color: #999;
  }
}

.explicit-summary {
  overflow: hidden;
  .inner {
    margin-bottom: 15px;
    padding: 9px 14px;
    font-size: 13px;
    line-height: 1.46;
    color: #333;
    background-color: #f8f8f8;
  }
  p {
    margin-bottom: 9px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.profit-empty {
  width: 100%;
  height: 300px;
  font-size: 14px;
  text-align: center;
  line-height: 300px;
}
</style>
